// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/seaplane-water-taxi-takeoff.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/seaplane-water-taxi-takeoff/seaplane-porpoising.js';
import g1 from '../lessons/aeronautics/seaplane-water-taxi-takeoff/seaplane-water-taxi-takeoff.js';

mount([g0, g1]);
